(() => {
  'use strict';

  // Announces adds without a visual banner and keeps line highlights and shipping progress in sync.
  const init = () => {
    const drawer = document.querySelector('#CartDrawer.gc-refresh');
    if (!drawer || drawer.dataset.gcRefreshReady) return;
    drawer.dataset.gcRefreshReady = 'true';

    const addedStatus = drawer.querySelector('[data-gc-added-status]');
    const products = drawer.querySelector('[data-products]');
    let pendingKeys = [];
    let campaignTimer = null;

    const updateBanner = () => {
      const banner = drawer.querySelector('[data-gc-compact-banner]');
      if (!banner) return;
      const count = Number(drawer.querySelector('[data-gc-summary]')?.dataset.count) || 0;
      const campaign = banner.querySelector('[data-gc-campaign]');
      const shipping = banner.querySelector('[data-gc-shipping]');
      const hasCampaign = campaign && !campaign.hidden && campaign.textContent.trim();
      const hasShipping = shipping && !shipping.hidden;
      banner.hidden = count === 0 || (!hasCampaign && !hasShipping);
    };

    const updateCampaign = () => {
      window.clearTimeout(campaignTimer);
      campaignTimer = null;
      const now = Date.now();
      let next = Infinity;
      drawer.querySelectorAll('[data-gc-campaign-end]').forEach(end => {
        const fromText = (end.dataset.showFrom || '').trim();
        const untilText = (end.dataset.hideAfter || '').trim();
        const from = Date.parse(fromText);
        const until = Date.parse(untilText);
        const started = !fromText || (Number.isFinite(from) && now >= from);
        const unexpired = !untilText || (Number.isFinite(until) && now < until);
        end.hidden = !(started && unexpired);
        for (const boundary of [from, until]) {
          if (Number.isFinite(boundary) && boundary > now) next = Math.min(next, boundary);
        }
      });
      updateBanner();
      if (Number.isFinite(next)) {
        campaignTimer = window.setTimeout(updateCampaign, Math.min(next - now + 1, 2147483647));
      }
    };

    const updateBar = () => {
      const shipping = drawer.querySelector('[data-gc-shipping]');
      const fill = drawer.querySelector('[data-gc-shipping-fill]');
      const details = drawer.querySelector('[data-gc-summary]');
      if (!shipping || !fill || !details) return;
      const threshold = Number(shipping.dataset.threshold) || 0;
      const total = Number(details.dataset.total) || 0;
      const percent = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 0;
      fill.style.width = percent + '%';
      const progress = shipping.querySelector('[data-gc-shipping-progress]');
      if (progress) {
        progress.setAttribute('aria-valuenow', String(Math.round(percent)));
        progress.setAttribute('aria-valuetext', shipping.querySelector('.gc-shipping-message')?.textContent.trim() || '');
      }
    };

    const highlight = () => {
      if (!pendingKeys.length || !products) return;
      const rows = pendingKeys
        .map(key => products.querySelector('.cart__item[data-line-key="' + CSS.escape(key) + '"]'))
        .filter(Boolean);
      if (!rows.length) return;
      pendingKeys = [];
      rows.forEach(row => {
        row.classList.add('gc-just-added');
        window.setTimeout(() => row.classList.remove('gc-just-added'), 2200);
      });
    };

    const hideAdded = () => { if (addedStatus) addedStatus.textContent = ''; };

    document.addEventListener('ajaxProduct:added', event => {
      const detail = event.detail?.product;
      const items = Array.isArray(detail?.items) ? detail.items : detail ? [detail] : [];
      if (!items.length) return;
      const first = items[0];
      const name = [first.product_title || first.title, first.variant_title]
        .filter(part => part && part !== 'Default Title')
        .join(' – ');
      if (addedStatus) {
        const label = addedStatus.dataset.label || 'Added to cart';
        addedStatus.textContent = label + ': ' + name + (items.length > 1 ? ' +' + (items.length - 1) : '');
      }
      pendingKeys = items.map(item => item.key).filter(Boolean);
      drawer.querySelector('.drawer__scrollable')?.scrollTo({ top: 0 });
      highlight();
    });

    // The confirmation belongs to the add that opened the drawer: clear it on close.
    new MutationObserver(() => {
      if (!drawer.classList.contains('drawer--is-open')) hideAdded();
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // Quantity or add-on changes inside the drawer make the confirmation stale. Listen on the
    // document so this runs before cart-sep26.js stops the event on the drawer.
    document.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : event.target?.parentElement;
      if (target && drawer.contains(target) && target.closest('.js-qty__adjust, .js-qty__adjust2, .removeIcon, [data-gc-upsell]')) hideAdded();
    }, true);

    const observer = new MutationObserver(() => { updateBar(); updateBanner(); highlight(); });
    drawer.querySelectorAll('[data-products], [data-cart-summary]').forEach(node => {
      observer.observe(node, { childList: true, subtree: true });
    });
    document.addEventListener('drawerOpen.CartDrawer', updateCampaign);
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) updateCampaign();
    });
    updateBar();
    updateCampaign();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
